import React from 'react';
import IconBadge from './IconBadge';
import { IconName } from './icons';

type CardProps = {
  variant?: 'flat' | 'raised';
  icon?: IconName;
  as?: 'article' | 'div' | 'li';
  className?: string;
  children: React.ReactNode;
};

/** The one card style: radius 20, 1 px line border, teal-tinted shadow, 28 px padding, 2 px lift on hover. */
const Card: React.FC<CardProps> = ({ variant = 'flat', icon, as: Tag = 'article', className, children }) => {
  const classes = ['ui-card', `ui-card--${variant}`];
  if (className) classes.push(className);
  return (
    <Tag className={classes.join(' ')}>
      {icon ? <IconBadge name={icon} className="ui-card__icon" /> : null}
      {children}
    </Tag>
  );
};

export default Card;
